var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[_c('router-link',{staticClass:"mr-2 btn btn-primary",attrs:{"to":{
      name: 'sendReport',
      query: {
        id: _vm.data.mode === 'company' ? _vm.data.companyId : _vm.data.branchId,
        accessLevel: _vm.data.mode === 'company' ? 'company' : 'branch',
        forward: 'false',
      },
    }}},[_vm._v("\n    "+_vm._s(_vm.data.sent === "Sent"
        ? _vm.$t("text.clickButtons.resend")
        : _vm.$t("text.clickButtons.send"))+"\n  ")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-info",attrs:{"to":{
      name: 'sendReport',
      query: {
        id: _vm.data.mode === 'company' ? _vm.data.companyId : _vm.data.branchId,
        type: _vm.data.mode,
        forward: 'true',
        accessLevel: _vm.data.mode === 'company' ? 'company' : 'branch',
      },
    }}},[_vm._v("\n    "+_vm._s(_vm.$t("text.clickButtons.forward"))+"\n  ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }